import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';

export interface ProposedActionArgumentsDialogData {
  functionId: string;
  arguments: string;
}

@Component({
  selector: 'ai-proposed-action-arguments-dialog',
  imports: [MatDialogModule, MatButtonModule, AiAssistantI18nModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 mat-dialog-title>{{ data.functionId }}</h2>
    <mat-dialog-content>
      <pre class="arguments">{{ data.arguments }}</pre>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      @use 'design-tokens' as *;

      .arguments {
        @include text-preset-5;
        margin: 0;
        padding: $spacing-3;
        background: $secondary-background-color;
        border-radius: $default-border-radius;
        white-space: pre-wrap;
        word-break: break-word;
      }
    `,
  ],
})
export class AiProposedActionArgumentsDialogComponent {
  readonly data = inject<ProposedActionArgumentsDialogData>(MAT_DIALOG_DATA);
}
